import { SHOW_BAG_BANNER, BAG_BANNER_SHOWN } from "./constants";

export { SHOW_BAG_BANNER, BAG_BANNER_SHOWN } from "./constants";

export { bagBannerShown } from "./actions";

export { getShowBagBanner, getBannerType } from "./selectors";

const initialState = {
  showBagBanner: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_BAG_BANNER:
      return {
        ...state,
        showBagBanner: true,
        bannerType: action.bannerType
      };
    case BAG_BANNER_SHOWN:
      return {
        ...state,
        showBagBanner: false
      };
    default:
      return state;
  }
};

export default reducer;
